import React, { Component } from 'react';
import { submit } from 'redux-form';
import { connect } from 'react-redux';
import qs from 'qs';
import { Modal, Icon, Button } from 'semantic-ui-react';
import moment from 'moment';
import { withRouter } from 'react-router';

import {
  MANAGE_MENU_PAGE_VIEWS,
  EDIT_MENU_QUERYSTRINGS,
  EDIT_MENU_TYPES,
} from 'Pages/managemenu/helpers/Constants';
import {
  EditAppliedMenuConfigFieldEnum as ConfigFields,
  AppliedMenuFieldEnum as AppliedMenuFields,
} from 'Common/FieldEnum';
import { APPLIED_MENU_CONFIG_FORM_NAME } from 'Common/FormEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

import { EditAppliedMenuConfigForm } from './EditAppliedMenuConfigForm';

class EditAppliedMenuConfigModal extends Component {
  get mainProps() {
    return {
      toolbox: {
        shown: true,
        backButtonProps: {
          path: `/managemenu?view=${MANAGE_MENU_PAGE_VIEWS.APPLIED_MENU}`,
          shown: true,
        },
        saveButtonProps: {
          content: 'Next',
        },
        formName: APPLIED_MENU_CONFIG_FORM_NAME,
      },
    };
  }

  handleSubmit = formValues => {
    const { history, menu } = this.props;

    const nextPageQueryParams = {
      [EDIT_MENU_QUERYSTRINGS.VIEW]: EDIT_MENU_TYPES.APPLIED_MENU,
      [EDIT_MENU_QUERYSTRINGS.START_DATE]: formValues[ConfigFields.StartDate],
      [EDIT_MENU_QUERYSTRINGS.END_DATE]: formValues[ConfigFields.EndDate],
      [EDIT_MENU_QUERYSTRINGS.ANALYSIS_DAYS]:
        formValues[ConfigFields.AnalysisDays],
      [EDIT_MENU_QUERYSTRINGS.SITE_ID]: menu[AppliedMenuFields.SiteId],
      [EDIT_MENU_QUERYSTRINGS.NUTRITION_STANDARD_ID]:
        menu[AppliedMenuFields.NutritionStdId],
      [EDIT_MENU_QUERYSTRINGS.DESCRIPTION]: menu[AppliedMenuFields.Description],
    };
    const queryString = qs.stringify(nextPageQueryParams);

    history.push(
      `/managemenu/edit/${menu[AppliedMenuFields.CycleMenuId]}?${queryString}`
    );
  };

  render() {
    const { modalProps, submit, menu } = this.props;
    const startDate = moment(menu[AppliedMenuFields.ServingDT]).format(
      DATE_FORMAT_FOR_UI
    );

    return (
      <Modal {...modalProps}>
        <Modal.Header className="manage-menu-modal-header ">
          Load Applied Menu Settings
          <Icon name="close" link onClick={modalProps.onClose} />
        </Modal.Header>
        <Modal.Content className="manage-menu-modal-content">
          <EditAppliedMenuConfigForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [ConfigFields.StartDate]: startDate,
              [ConfigFields.EndDate]: startDate,
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={modalProps.onClose} className="mnm-button-blue">
            Cancel
          </Button>
          <Button
            onClick={() => submit(APPLIED_MENU_CONFIG_FORM_NAME)}
            className="mnm-button-blue"
          >
            Next
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

EditAppliedMenuConfigModal = withRouter(
  connect(null, {
    submit,
  })(EditAppliedMenuConfigModal)
);

export { EditAppliedMenuConfigModal };



// WEBPACK FOOTER //
// ./src/pages/managemenu/components/EditAppliedMenuConfigModal.js